export default "__VITE_ASSET__D4Pe4yG9__"